import { reactive } from 'vue';
import axios from 'axios';
import lib from '@/lib';
import { relativeTimeThreshold } from 'moment';

import BuildingQueue from '@/classes/game/BuildingQueue';

export default class BuildingQueueModel {
	constructor() {
		this.show = true;
		
		this.activeSlot = {
			slotHover: null,
			detailHover: null,
			slot: null,
			slotDetail: null,
		};
		
		this.slotBuildHover = false;
		this.slotDestructionHover = false;
		this.slot1Hover = false;
		this.slot2Hover = false;
		this.slot3Hover = false;
		this.slot4Hover = false;
		
		this.detailBuildHover = false;
		this.detailDestructionHover = false;
		this.detail1Hover = false;
		this.detail2Hover = false;
		this.detail3Hover = false;
		this.detail4Hover = false;
		
		this.queues = reactive({
			[BuildingQueue.TYPE_DESTRUCTION]: [
				{
					queueType: BuildingQueue.TYPE_DESTRUCTION,
					locationId: 1,
					buildingType: 8,
					buildingName: 'Лесопилка',
					lvl: 1,
					isRubble: true, // руины
					enoughResources: true,
					paid: true,
					slot: null,
					duration: ((((1 * 60) + 15) * 60) + 9),
					timeStart: (Date.now() / 1000),
					timeFinish: (Date.now() / 1000) + ((((1 * 60) + 15) * 60) + 9),
					cost: [
						2915,
						2790,
						0,
						2915,
						//1000,
						68000,
					],
				},
			],
			[BuildingQueue.TYPE_BUILD]: [
				{
					queueType: BuildingQueue.TYPE_BUILD,
					locationId: 12,
					buildingType: 8,
					buildingName: 'Лесопилка',
					lvl: 1,
					isRubble: false, // руины
					enoughResources: true,
					paid: true,
					slot: null,
					duration: ((((0 * 60) + 1) * 60) + 9),
					timeStart: (Date.now() / 1000),
					timeFinish: (Date.now() / 1000) + ((((0 * 60) + 1) * 60) + 9),
					cost: [
						2915,
						2790,
						0,
						2915,
						1000,
					],
				},
			],
			[BuildingQueue.TYPE_BUILD_QUEUE]: [
				{
					queueType: BuildingQueue.TYPE_BUILD_QUEUE,
					locationId: 10,
					buildingType: 9,
					buildingName: 'Лесопилка',
					lvl: 1,
					isRubble: false, // руины
					enoughResources: true,
					paid: false,
					slot: 1,
					duration: ((((1 * 60) + 15) * 60) + 9),
					timeStart: (Date.now() / 1000),
					timeFinish: (Date.now() / 1000) + ((((1 * 60) + 15) * 60) + 9),
					cost: [
						2915,
						2790,
						0,
						2915,
						1000,
					],
				},
				{
					queueType: BuildingQueue.TYPE_BUILD_QUEUE,
					locationId: 2,
					buildingType: 10,
					buildingName: 'Лесопилка',
					lvl: 1,
					isRubble: false, // руины
					enoughResources: false,
					paid: false,
					slot: 2,
					duration: ((((1 * 60) + 15) * 60) + 9),
					timeStart: (Date.now() / 1000),
					timeFinish: (Date.now() / 1000) + ((((1 * 60) + 15) * 60) + 9),
					cost: [
						291500,
						2790,
						0,
						2915,
						1000,
					],
				},
			],
		});
		this.availableBuildQueueSlots = 2;
	}
	
	queuesByTypes() {
		return this.queues.reduce((acc, obj) => {
			if (!acc[obj.type]) acc[obj.type] = [];
			acc[obj.type].push(obj);
			return acc;
		}, {});
	}
	
	activeSlotSelType() {
		return this.activeSlot.slotHover || this.activeSlot.detailHover;
	}
	
	activeSlotSelSlot() {
		return this.activeSlot.slot || this.activeSlot.slotDetail;
	}
	
	activeSlotSelData() {
		if (this.activeSlotSelType()) {
			return this.queues[this.activeSlotSelType()].find(el => el.slot == this.activeSlotSelSlot()) || null;
		}
		return null;
	}
}
